module.exports = __webpack_public_path__ + "img/confirmation-email-sv.fb486018.png";